import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild, ɵunwrapSafeValue as unwrapSafeValue } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LoadingController } from '@ionic/angular';
import { isUndefined } from 'src/app/services/codeUtils';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { UniqueIDService } from 'src/app/services/unique-id/unique-id.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { WebcontentService } from 'src/app/services/webcontent/webcontent.service';

@Component({
  selector: 'app-webcontent',
  templateUrl: './webcontent.component.html',
  styleUrls: ['./webcontent.component.scss'],
})
export class WebcontentComponent implements OnInit {
  @ViewChild('iFrameParent') iframeParent: ElementRef;

  @Input() iHeight: any = '0px';
  @Input() uniqueName: string = '';
  @Input() listenReloadExternallinksEvent: boolean = true;
  @Input() overrideStyle: boolean = false;
  @Input() srcUrlEx: string = "";
  @Input() isScrollable: boolean = false;

  public srcUrl: any;
  public linkAvailable: boolean = false;
  public loading: any;
  public loadingDuration: number;

  constructor(
    private childElement: ElementRef,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer,
    public config: ConfigService,
    public events: EventsService,
    public loadingController: LoadingController,
    public utils: UtilsService,
    public webcontentService: WebcontentService,
    public uniqueIDService: UniqueIDService
  ) {
    if (!this.uniqueName) {
      this.uniqueName = uniqueIDService.uuidv4();
    }
    this.loadingDuration = this.config.getConfig().FEATURE_DEFAULT_LOADING_DURATION ?? 1200;

    window.addEventListener('message', (event: MessageEvent) => {
      if (event.data.type === 'resizeIframe') {

        var iframe: HTMLElement = this.getIframeElement();
        if (this.uniqueName === event.data.params.uniqueName) {
          iframe.style.height = event.data.params.height + 'px';
        }
      }
    });

  }

  ngOnInit() {
    this.showLoading();
    this.loadContent();
    if (this.listenReloadExternallinksEvent) {
      this.events.subscribe("event:reload:externallinks", (data) => {
        if (data) this.loadContent()
      });
    }
  }

  protected iFrameElement: any;
  ngAfterViewChecked(): void {
    this.iFrameElement = this.getIframeElement() as HTMLIFrameElement;
    if (this.iframeParent && !this.iFrameElement) {
      //`<iframe #iFrameId [src]="${this.srcUrl} | safeurl" frameborder="0" width="100%" scrolling="no" id="${this.uniqueName}" name="${this.uniqueName}" [style.min-height]="${this.iHeight}"></iframe>`
      const srcUrlSafe = this.sanitizer.bypassSecurityTrustUrl(this.srcUrl);
      const iframe = this.renderer.createElement('iframe') as HTMLIFrameElement;
      iframe.name = this.uniqueName;
      iframe.style.minHeight = this.iHeight;
      iframe.src = unwrapSafeValue(srcUrlSafe);
      iframe.width = "100%";
      iframe.scrolling = this.isScrollable ? "yes" : "no";
      iframe.frameBorder = "0"
      this.renderer.appendChild(this.iframeParent.nativeElement, iframe);

      if (iframe) {
        iframe.onload = () => {
          this.loading?.dismiss();
        };
      }
    }
  }

  async showLoading() {
    this.loading = await this.loadingController.create({
      message: 'Please wait loading...',
      duration: this.loadingDuration
    });

    this.loading.present();
  }

  protected getIframeElement(): HTMLElement {
    return this.childElement.nativeElement.getElementsByTagName('iframe')[0];
  }

  getExternalLinkValue(): string {
    let link: any;
    this.webcontentService._externalLinkValue.subscribe(res => link = res);
    return link;
  }

  ionViewWillLeave() {
    this.webcontentService.updateExternalLink(null);
    this.srcUrl = null;
  }

  public loadContent(): any {
    this.linkAvailable = true;
    let updatedLink: string = this.srcUrlEx || this.getExternalLinkValue();
    if (!isUndefined(updatedLink)) {
      let cleanUrl = this.utils.cleanPathName(updatedLink);
      this.srcUrl = this.webcontentService.getDocContentUrl(cleanUrl);

      const iFrameElement = this.getIframeElement() as HTMLIFrameElement;
      if (iFrameElement) {
        const srcUrlSafe = this.sanitizer.bypassSecurityTrustUrl(this.srcUrl);
        iFrameElement.src = unwrapSafeValue(srcUrlSafe);
      }
      return;
    }
    this.linkAvailable = false;
    return;
  }
}
